import { FC } from "react";

import { AverageConsumptionLineChart, AverageConsumptionDataPoint } from "../AverageConsumptionLineChart/AverageConsumptionLineChart";
import { AVERAGE_ENERGY_CONSUMPTION_WASHING_MACHINES_DATA_KEYS } from "./AverageEnergyConsumptionWashingMachines.const";

const AverageEnergyConsumptionWashingMachines: FC<{ data: AverageConsumptionDataPoint[] }> = ({ data }) => (
	<AverageConsumptionLineChart
		data={data}
		yAxisLabel="Average energy consumption of washing machines"
		chartSubtitle="(kWh per cycle)"
		yDomain={[0, 2]}
		yTickCount={5}
		dataKeys={AVERAGE_ENERGY_CONSUMPTION_WASHING_MACHINES_DATA_KEYS}
	/>
);

export { AverageEnergyConsumptionWashingMachines };
